<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONVÊNIO -
                            <strong>{{ convenio.vcCodigoEstruturado }}</strong>
                            <b-badge variant="warning" class="ml-2">{{operacao}}</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Cadastrais" active class="pb-0">
                                <Dados-Cadastrais
                                    :convenio="convenio"
                                ></Dados-Cadastrais>
                            </b-tab>
                            <b-tab title="Prestação de Contas" class="pb-0" v-if="temAcessoPrestacaoMensal">
                                <Prestacao-Mensal
                                    :convenio="convenio"
                                    :dataServicos="dataServicos"
                                    :permiteCadastrarPrestacaoMensal="permiteCadastrarPrestacaoMensal"
                                    :permiteExcluirJustificarPrestacaoMensal="permiteExcluirJustificarPrestacaoMensal"
                                    :permiteEnviarPrestacaoParaAnalise="permiteEnviarPrestacaoParaAnalise"
                                    :temAcessoPrestacaoFinal="temAcessoPrestacaoFinal"
                                    :permiteCadastrarPrestacaoFinal="permiteCadastrarPrestacaoFinal"
                                    :permiteExcluirPrestacaoFinal="permiteExcluirPrestacaoFinal"
                                    :permiteAtualizarPrestacaoFinal="permiteAtualizarPrestacaoFinal"
                                    :permiteAcessarDocumentos="permiteAcessarDocumentos"
                                    :permiteCadastrarDocumentos="permiteCadastrarDocumentos"
                                    :permiteExcluirDocumentos="permiteExcluirDocumentos"
                                ></Prestacao-Mensal>
                            </b-tab>
                            <b-tab title="Plano de Trabalho" class="pb-0" v-if="temAcessoAcoesPlanoTrabalho">
                                <plano-trabalho
                                    :convenio="convenio"
                                    :acoesPlanoTrabalhoConvenio="convenio.acoesPlanoTrabalho"
                                    :dataServicos="dataServicos"
                                    :temAcessoEventos="temAcessoEventos"
                                    :permiteInserirAtualizarEventos="permiteInserirAtualizarEventos"
                                    :permiteCancelarEventos="permiteCancelarEventos"
                                    :temAcessoDocumentosEvento="temAcessoDocumentosEvento"
                                    :temAcessoMetas="temAcessoMetas"
                                    :temAcessoConsultoria="temAcessoConsultoria"
                                    :temAcessoEntrega="temAcessoEntrega"
                                    :permiteInserirMetas="permiteInserirMetas"
                                    :permiteCancelarMetas="permiteCancelarMetas"
                                    :permiteInserirAtualizarAcoesPlanoTrabalho="permiteInserirAtualizarAcoesPlanoTrabalho"
                                    :permiteCancelarAcoesPlanoTrabalho="permiteCancelarAcoesPlanoTrabalho"
                                    :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
                                ></plano-trabalho>
                            </b-tab>
                            <b-tab title="Licitações" class="pb-0" v-if="temAcessoLicitacoes">
                                <licitacoes
                                    :convenio="convenio"
                                    :permiteInserirLicitacao="permiteInserirLicitacao"
                                    :permiteAtualizarLicitacao="permiteAtualizarLicitacao"
                                    :permiteExcluirLicitacao="permiteExcluirLicitacao"
                                    :temAcessoDocumentosLicitacoes="temAcessoDocumentosLicitacoes"
                                ></licitacoes>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DadosCadastrais from './ConvenioDadosCadastrais'
import PrestacaoMensal from './ConvenioPrestacaoContasMensal'
import PlanoTrabalho from './ConvenioPlanoTrabalho'
import Licitacoes from './ConvenioLicitacoes'

    export default {
        props: {
            dataServicos: {
                type: Object
            },

            rotaListagem: {
                type: String
            },
            temAcessoPrestacaoMensal: {
                type: Boolean,
                default: () => false
            },
            permiteCadastrarPrestacaoMensal: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirJustificarPrestacaoMensal: {
                type: Boolean,
                default: () => false
            },
            permiteEnviarPrestacaoParaAnalise: {
                type: Boolean,
                default: () => false
            },
            temAcessoPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteCadastrarPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteAtualizarPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteAcessarDocumentos: {
                type: Boolean,
                default: () => false
            },
            permiteCadastrarDocumentos: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirDocumentos: {
                type: Boolean,
                default: () => false
            },
            temAcessoEventos: {
                type: Boolean,
                default: () => false
            },
            permiteInserirAtualizarEventos: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarEventos: {
                type: Boolean,
                default: () => false
            },
            temAcessoDocumentosEvento: {
                type: Boolean,
                default: () => false
            },
            temAcessoMetas: {
                type: Boolean,
                default: () => false
            },
            temAcessoConsultoria: {
                type: Boolean,
                default: () => false
            },
            temAcessoEntrega: {
                type: Boolean,
                default: () => false
            },
            permiteInserirMetas: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarMetas: {
                type: Boolean,
                default: () => false
            },
            temAcessoAcoesPlanoTrabalho: {
                type: Boolean,
                default: () => false
            },
            permiteInserirAtualizarAcoesPlanoTrabalho: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarAcoesPlanoTrabalho: {
                type: Boolean,
                default: () => false
            },
            permiteInserirCancelarDocumentosEvento: {
                type: Boolean,
                default: () => false
            },
            temAcessoLicitacoes: {
                type: Boolean,
                default: () => false
            },
            permiteInserirLicitacao: {
                type: Boolean,
                default: () => false
            },
            temAcessoDocumentosLicitacoes: {
                type: Boolean,
                default: () => false
            },
            permiteAtualizarLicitacao: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirLicitacao: {
                type: Boolean,
                default: () => false
            }
        },
        components: {
            DadosCadastrais,
            PrestacaoMensal,
            PlanoTrabalho,
            Licitacoes
        },
        

        data() {
            return {
                convenio: {},
                //dadosRm: {},
                operacao: 'DETALHAR',
                tabIndex: 0,
                erros: []
            }
        },

        methods: {
            voltar() {
                this.$router.push({ name: this.rotaListagem })
            },

            obterConvenio() {
                this.$store.dispatch('addRequest')
                this.dataServicos.ObterConvenioPorId(this.$route.params.idConvenio).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            },
        },

        created() {
            this.obterConvenio()
        },
    }
</script>
